'use strict';

import './component.scss';
import reflow from './reflow';

reflow();
